import { useEffect, useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, MenuItem, Stack, IconButton, Popover, Button } from '@mui/material';
import { glb_sv, session } from 'src/utils';
import Iconify from 'src/components/iconify/Iconify';
import { useTranslation } from 'react-i18next';
import en from '../../../image/language/en.png';

// ----------------------------------------------------------------------

const LANGS = [
    {
        value: 'vi',
        label: 'Việt Nam',
        icon: '/assets/icons/vietnam_icon.svg',
    },
    {
        value: 'en',
        label: 'English',
        icon: en,
    },
    {
        value: 'jp',
        label: 'Japan',
        icon: '/assets/icons/japan_nation_icon.svg',
    },
];

// ----------------------------------------------------------------------

export default function LanguagePopover() {
    const [open, setOpen] = useState(null);
    const [lange, setLange] = useState(glb_sv.language);
    const [index, setIndex] = useState(0);

    const { t, i18n } = useTranslation();
    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    const handleClose = (lange, index) => {
        setLange(lange);
        setIndex(index);
        glb_sv.language = lange;
        setOpen(null);
        console.log('language handleClose', lange);
        sessionStorage.setItem(session.LOCAL_LANGUAGE, lange);
        localStorage.setItem(session.LOCAL_LANGUAGE, lange);
    };

    useEffect(() => {
        const language = localStorage.getItem(session.LOCAL_LANGUAGE);
        console.log('useEffect', language);

        if (language) {
            setLange(language);
        }
        i18n.changeLanguage(language);
        if (language === 'en') {
            setIndex(1);
        }
        if (language === 'jp') {
            setIndex(2);
        }
    }, [glb_sv.language]);

    return (
        <>
            <IconButton
                onClick={handleOpen}
                sx={{
                    padding: 0,
                    width: 44,
                    height: 44,
                    ...(open && {
                        bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
                    }),
                }}
            >
                <img src={LANGS[index]?.icon} alt={LANGS[index]?.label} width={33} />
                {/* <Iconify color="primary" icon="material-symbols:shopping-cart" width={10} height={10} /> */}
            </IconButton>

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                // onBlur={() => }
                onClose={() => setOpen(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        p: 1,
                        mt: 1.5,
                        ml: 0.75,
                        width: 180,
                        '& .MuiMenuItem-root': {
                            px: 1,
                            typography: 'body2',
                            borderRadius: 0.75,
                        },
                    },
                }}
            >
                <Stack spacing={0.75}>
                    {LANGS.map((option, idx) => (
                        <MenuItem
                            key={idx}
                            selected={option.value === LANGS[index].value}
                            onClick={() => handleClose(option.value, idx)}
                        >
                            <Box component="img" alt={option.label} src={option.icon} sx={{ width: 28, mr: 2 }} />

                            {option.label}
                        </MenuItem>
                    ))}
                </Stack>
            </Popover>
        </>
    );
}
